import { useRequest } from 'ahooks'
import { useEthersProvider } from './useEthersProvider'

const useBalanceOfNativeToken = (address: string) => {
  const provider = useEthersProvider()

  return useRequest(
    async () => {
      return provider.getBalance(address)
    },
    {
      ready: !!provider?.getBalance,
      refreshDeps: [address],
    },
  )
}

export default useBalanceOfNativeToken
